module.exports = __webpack_public_path__ + "img/text_only_hero_org.45ed043e.png";